/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSyncEntitiesByTarget} from '../api'

 export const useQueryGetSyncEntitiesByTarget = createReactQueryHook('getSyncEntitiesByTarget', getSyncEntitiesByTarget)
